import React, {FunctionComponent, useEffect, useState} from "react";
import {LogoBox} from "../boxes/logoBox/logoBox.component";
import {BackgroundShape} from "../backgroundShape/backgroundShape.component";
import {SectionWithBackgroundShape} from "../../interfaces/sectionWithBackgroundShape.interface";
import {StrapiImageData} from "../../interfaces/strapi/strapiImage.interface";
import {SectionPadding} from "../../enums";

const styles = require("./homepageLogos.component.scss");

interface HomepageLogosProps extends SectionWithBackgroundShape{
    title: string;
    logos: StrapiImageData[];
    sectionPadding: SectionPadding;
}


export const HomepageLogos: FunctionComponent<HomepageLogosProps> = props => {
    const {title, logos, backgroundShape, sectionPadding} = props;

    return (
        <div className={styles.cardBackground}>
            {!!backgroundShape &&
                <BackgroundShape {...backgroundShape}/>
            }
            <div className={`${styles.cardWrapper} ${styles[sectionPadding]}`}>
                <h2 className={styles.logosTitle}>
                    {title}
                </h2>
                <div className={styles.rowContainer}>
                    {logos.map((logo, index) =>
                        <LogoBox key={index} size={'huge'} image={logo?.url}/>
                    )}
                </div>
            </div>
        </div>
    );
};
